import React from 'react';
import { CtaButton } from './CtaButton';
export function PricingSection() {
  return <section id="pricing" className="bg-black py-16 px-6 flex flex-col items-center text-center w-full" data-id="element-153">
      <div className="max-w-7xl mx-auto flex flex-col items-center" data-id="element-154">
        <p className="text-white font-serif text-xl md:text-2xl mb-2" data-id="element-155">
          ¡Este valor especial estará sólo por tiempo limitado!
        </p>
        <h2 className="text-white font-serif font-bold text-4xl md:text-6xl mb-10 underline decoration-white/30 underline-offset-8" data-id="element-156">
          ACCEDÉ AHORA
        </h2>

        {/* Offer Card */}
        <div className="w-full max-w-xl bg-[#fdf2e9] rounded-[2.5rem] overflow-hidden flex flex-col items-center pb-10 shadow-2xl" data-id="element-157">
          {/* Main Mockup */}
          <img src="https://cdn.magicpatterns.com/uploads/p3ogb6j1yeC81svYinY9QR/pasted-image.png" alt="Mockup completo del programa" className="w-full h-auto mb-4 md:scale-105" data-id="element-158" />

          {/* Benefits List */}
          <ul className="text-left px-8 w-full space-y-3 mb-6 md:grid md:grid-cols-1 md:gap-4 max-w-md" data-id="element-159">
            {['Acceso Permanente', 'Soporte + Actualizaciones', '6 BONOS de regalo 🎁', 'Garantía de satisfacción', <>
                <strong data-id="element-160">CONSULTORÍAS EN VIVO SEMANALES</strong>{' '}
                <em className="not-italic opacity-70" data-id="element-161">(opcional)</em>
              </>].map((item, i) => <li key={i} className="flex gap-3 font-serif text-brand-navy text-lg items-start" data-id="element-162">
                <span className="text-xl shrink-0 font-bold" data-id="element-163">✓</span>
                <span data-id="element-164">{item}</span>
              </li>)}
          </ul>

          {/* Pricing */}
          <div className="flex flex-col items-center w-full px-6" data-id="element-165">
            <p className="text-red-600 font-serif font-bold text-xl md:text-2xl line-through mb-1" data-id="element-166">
              ANTES $149.999 ARS
            </p>
            <p className="text-brand-navy font-serif font-bold text-3xl md:text-4xl mb-2" data-id="element-167">
              ¡SÓLO POR HOY! 😱
            </p>
            <p className="text-[#00c853] font-serif font-bold mb-4 text-[48px] md:text-[64px]" data-id="element-168">
              $49.999 ARS
            </p>

            <div className="bg-[#00c853] text-white py-2 px-6 rounded-full flex items-center gap-2 mb-3 md:scale-110" data-id="element-169">
              <span className="font-bold text-sm" data-id="element-170">100% recomendado</span>
              <span className="text-yellow-400" data-id="element-171">⭐⭐⭐⭐⭐</span>
            </div>

            <p className="text-brand-navy font-serif text-lg md:text-xl mb-4" data-id="element-172">
              Hasta 3 cuotas
            </p>
          </div>

          {/* CTA Button */}
          <div className="px-6 w-full mb-2 md:scale-110 md:my-4" data-id="element-173">
            <CtaButton variant="gold" className="shadow-2xl" href="https://f13dpf-q0.myshopify.com/cart/46012643770522:1?channel=buy_button" data-id="element-174">
              ¡SI QUIERO ACCEDER AHORA!
            </CtaButton>
          </div>

          {/* Payment Badges */}
          <div className="flex flex-col items-center gap-0 px-6 w-full" data-id="element-175">
            <img src="https://cdn.magicpatterns.com/uploads/44z9xaHtawe7BTcTJNsVaK/pasted-image.png" alt="Pago 100% Seguro" className="h-28 md:h-36 w-auto block mt-[-10px] mb-[-10px]" data-id="element-176" />
            <img src="https://cdn.magicpatterns.com/uploads/ge1DUvrF2zTiRQSURyErs2/pasted-image.png" alt="Métodos de pago" className="w-full h-auto max-w-full px-2 block mt-[-85px] mb-[-80px] md:mt-[-110px] md:mb-[-100px]" data-id="element-177" />
          </div>
        </div>

        {/* Guarantee Section */}
        <div className="mt-16 flex flex-col items-center max-w-2xl" data-id="element-178">
          <img src="https://cdn.magicpatterns.com/uploads/kW4kdNR8UyZcBD7bgX4jqC/pasted-image.png" alt="Garantía de 7 días" className="w-48 md:w-64 h-auto mb-8" data-id="element-179" />

          <p className="text-white font-sans text-[19px] md:text-[22px] leading-relaxed italic px-2 mb-12" data-id="element-180">
            Estoy tan segura de que este curso te va a{' '}
            <span className="underline" data-id="element-181">transformar y encantar</span>, que si
            seguís el paso a paso y no es así,{' '}
            <strong className="font-bold" data-id="element-182">
              te devuelvo el 100% de tu dinero
            </strong>
            . Tenés 7 días para probarlo sin riesgo. Me escribís y te hago el
            reembolso.
          </p>

          <div className="space-y-6 w-full max-w-md" data-id="element-183">
            <h3 className="text-white font-sans font-bold text-3xl md:text-4xl" data-id="element-184">
              ¿Dudas? <br data-id="element-185" /> ¡Comunícate conmigo!
            </h3>

            <a href="https://api.whatsapp.com/send/?phone=5491169196692&text=Hola+Quiero+acceder+a+la+formular+creadora+de+contenido+UGC.+Mi+nombre+es+&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer" className="block w-full max-w-sm mx-auto transition-transform hover:scale-105 active:scale-95" data-id="element-186">
              <img src="https://cdn.magicpatterns.com/uploads/jywVCyikDEJMp2T5JmNzTH/pasted-image.png" alt="Whatsapp Soporte" className="w-full h-auto drop-shadow-xl" data-id="element-187" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}